import { render, staticRenderFns } from "./XlsCsvParser.vue?vue&type=template&id=070cc664"
import script from "./XlsCsvParser.vue?vue&type=script&lang=js"
export * from "./XlsCsvParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports